import React, { useState } from 'react';
import { Result } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useHistory, useLocation } from 'react-router-dom';
import Hero from 'components/Hero';
import useGlobalContext from 'hooks/useGlobalContext';
import { useAsyncEffect } from 'ahooks';
import useAuth from '../../hooks/useAuth';

const DemoLogin = () => {
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const { demoLogin } = useAuth();
  const { modal } = useGlobalContext();

  useAsyncEffect(async () => {
    try {
      await demoLogin();
      const referrer = location?.state?.referrer ?? '/';
      history.replace(referrer);
    } catch (e) {
      modal.error({ content: e.message, centered: true });
      console.error(e);
    }
    setLoading(false);
  }, []);

  return (
    <Hero branded>
      {loading && (
      <Result
        icon={<LoadingOutlined />}
        title="Logging in"
      />
      )}
    </Hero>
  );
};

export default DemoLogin;
